import React from 'react';
import styled from 'styled-components';

interface MobileOverlayProps {
    isOpen: boolean;
    onClick: () => void;
}

export const MobileOverlay: React.FC<MobileOverlayProps> = ({ isOpen, onClick }) => {
    if (!isOpen) return null;

    return <StyledOverlay onClick={onClick} />;
};

const StyledOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 998;
  opacity: 0;
  animation: fadeIn 0.3s ease-in-out forwards;

  @keyframes fadeIn {
    to {
      opacity: 1;
    }
  }

  @media (min-width: 769px) {
    display: none;
  }
`;
